import { z } from 'zod';
export const createNewAccountRequestSchema = z.object({
    account_title: z.string().min(1, 'Account title is required'),
    account_type: z.string().nullable().optional(),
    is_ira: z.boolean().optional().default(false),
    ira_custodian: z.string().nullable().optional(),
    contact_name: z.string().nullable().optional(),
    contact_email: z.string().email().nullable().optional(),
    contact_phone: z.string().nullable().optional(),
    address1: z.string().nullable().optional(),
    address2: z.string().nullable().optional(),
    city: z.string().nullable().optional(),
    state: z.string().nullable().optional(),
    zip: z.string().nullable().optional(),
    country: z.string().nullable().optional().default('US'),
    hubspot_contact_id: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
});
export const updateNewAccountRequestSchema = createNewAccountRequestSchema.partial();
//# sourceMappingURL=new-account.js.map